import { renderPage } from "renderPage"
import { ClubTestimonyIndexPage } from "./Page"

renderPage({ component: ClubTestimonyIndexPage })
